































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Form } from '@/models/Form';
import { FormElement, FormElementData } from '@/models/FormElement';
import { BDropdown, BDropdownItem, BOverlay } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import { IFormElementTags } from '@/store/modules/formElementTags';
import ModalVisibilityRuleSets from '@/components/modals/VisibilityRuleSets.vue';
import ModalFormElementDelete from '@/components/modals/FormElementDelete.vue';

@Component({
    name: 'CardFormElement',
    components: {
        'b-overlay': BOverlay,
        'b-dropdown': BDropdown,
        'b-dropdown-item': BDropdownItem,
        'modal-visibility-rule-sets': ModalVisibilityRuleSets,
        'modal-form-element-delete': ModalFormElementDelete,
    },
    computed: mapGetters({
        formElementTags: 'formElementTags/all',
        visibilityRuleSets: 'visibilityRuleSets/all',
    }),
})
export default class CardFormElement extends Vue {
    updating = false;
    collapsed = true;
    hover = false;
    ruleTarget: FormElement | null = null;

    @Prop() form!: Form;
    @Prop() element!: FormElement;
    @Prop() input!: FormElementData;

    formElementTags!: IFormElementTags;

    get title() {
        return this.element.title;
    }

    set title(title: string) {
        this.$emit('element:title', title);
    }

    get tags() {
        return this.element.tags.filter((id: number) => {
            return this.formElementTags && this.formElementTags[this.form.uri]
                ? this.formElementTags[this.form.uri][id]
                : false;
        });
    }

    set tags(tags: number[]) {
        this.$emit('element:tags', tags);
    }

    async update() {
        this.updating = true;
        try {
            const element = await this.$store.dispatch('formElements/update', {
                id: this.element.id,
                title: this.element.title,
                tags: this.element.tags.map((tagId: number) => {
                    return `/api/form_element_tags/${tagId}`;
                }),
                params: this.input,
            });
            this.$store.commit('forms/setElement', element);
        } catch (e) {
            // TODO Catch error
        } finally {
            this.updating = false;
        }
    }
}
